/* eslint-disable padding-line-between-statements */
// actions/zoning.actions.ts
export const storeZones = (zones) => ({
	  type: "storeZones",
	  payload: zones // Use "payload" instead of "data"
	});
  
  export const storeAllZones = (zone) => ({
	  type: "storeAllZones",
	  payload: zone // Use "payload" instead of "data"
	});
  export const visabilityOfErrorPage = (boolValue) => ({
	  type: "visabilityOfErrorPage",
	  payload: boolValue // Use "payload" instead of "data"
	});
  